import { Button } from '@cocoonspace/ui/components/button'
import {
	Card,
	CardFooter,
	CardHeader,
	CardTitle,
} from '@cocoonspace/ui/components/card'
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@cocoonspace/ui/components/tabs'
import { useLingui } from '@lingui/react/macro'

import { useProfileFormContext } from '../use-profile-form.hook'
import { ProfileCustomizationFields } from './profile-customization-fields'
import { ProfileGeneralFields } from './profile-general-fields'
import { ProfileLinksFields } from './profile-links-fields'

export const GeneralProfileInfoForm = () => {
	const { t } = useLingui()
	const form = useProfileFormContext()

	return (
		<>
			<CardHeader className='mb-0 p-4'>
				<CardTitle>{t`Modifier le profil`}</CardTitle>
			</CardHeader>

			<Card
				variant='outline'
				className='m-4 mt-0 flex flex-col divide-y overflow-hidden'
			>
				<Tabs defaultValue='general'>
					<TabsList className='border-border w-full justify-start rounded-b-none border-b px-4 py-3 shadow-none!'>
						<TabsTrigger value='general'>
							{t`Informations générales`}
						</TabsTrigger>

						<TabsTrigger value='customization'>
							{t`Personnalisation`}
						</TabsTrigger>

						<TabsTrigger value='links'>{t`Liens externes`}</TabsTrigger>
					</TabsList>

					<TabsContent value='general'>
						<div className='p-4 py-2'>
							<ProfileGeneralFields />
						</div>
					</TabsContent>

					<TabsContent value='links'>
						<div className='p-4 py-2'>
							<ProfileLinksFields />
						</div>
					</TabsContent>

					<TabsContent value='customization'>
						<div className='p-4 py-2'>
							<ProfileCustomizationFields />
						</div>
					</TabsContent>
				</Tabs>

				<CardFooter className='border-0! p-4'>
					<Button
						type='submit'
						disabled={form.formState.isSubmitting}
						className='w-full'
					>
						{t`Enregistrer`}
					</Button>
				</CardFooter>
			</Card>
		</>
	)
}
